import { AssetSearchFilters } from "../transportation/models/filters/asset-search-filters";
import { ContainerSearchFilters } from "../transportation/models/filters/container-search-filters";
import { DeliveryPlanningFilters } from "../transportation/models/filters/delivery-planning-filters";
import { DriverSearchFilters } from "../transportation/models/filters/driver-search-filters";
import { PickupSearchFilters } from "../transportation/models/filters/pickup-search-filters";
import { TruckSearchFilters } from "../transportation/models/filters/truck-search-filters";
import { BaseModuleState } from "./_BaseModuleState";

export class TransportationModuleState extends BaseModuleState {

    // Deliveries
    public truckSearchFilters   : TruckSearchFilters | undefined = undefined;    
    // Pickups
    public pickupsSearchFilters : PickupSearchFilters | undefined = undefined;
    // Containers
    public containerSearchFilters : ContainerSearchFilters | undefined = undefined;    
    // Assets 
    public assetSearchFilters : AssetSearchFilters | undefined = undefined;
    // Driver
    public driversSearchFilters: DriverSearchFilters | undefined = undefined;

    // Communications
    public communicationsTruckSearchFilters: TruckSearchFilters | undefined = undefined;
    public communicationsContainerSearchFilters: ContainerSearchFilters | undefined = undefined;

    // Planning
    public deliveryPlanningFilters : DeliveryPlanningFilters | undefined = undefined;

    // Tab States
    public selectedPlanningTab : string | undefined = undefined;
    public selectedShipmentTab : string | undefined = undefined;
    public selectedFleetTab: string | undefined = undefined;
    public selectedCommunictionsTab: string | undefined = undefined;
}
